// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__3EVBt","accent":"button_accent__3dcsD button_root__3EVBt"};